import { render, staticRenderFns } from "./ScenkonstStaff.vue?vue&type=template&id=06d17ea8&"
import script from "./ScenkonstStaff.vue?vue&type=script&lang=ts&"
export * from "./ScenkonstStaff.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports